export default __webpack_public_path__ + "static/media/sufficient_balance.abea92d3.svg";